import { KycProcessStatus, type KycResponse } from '@repo/api-kit/queries/due-diligence/kyc';

export function isKycSubmitted(kycInfo?: KycResponse | null) {
  return kycInfo?.activeProcess?.processStatus === KycProcessStatus.submitted;
}
